import { Button, Dialog, Typography } from "@mui/material"
import { ModelInsidePanorama } from "api"
import dynamic from "next/dynamic"
import Image from "next/image"
import { useState } from "react"
import CloseIcon from "reusable/icons/CloseIcon"
import TablerView360Icon from "reusable/icons/TablerView360Icon"
import styled from "styled-components"

const PhotoSphereComponent = dynamic(() => import("./PhotoSphereComponent"), {
  ssr: false,
})

const StyledImageWrapper = styled.div`
  width: 100%;
  height: 100vh;
  position: relative;
  background: ${(p) => p.theme.colors.black};
  img {
    object-fit: contain;
  }
`
const StyledInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 10;
  margin-top: 65px;
`
const StyledText = styled(Typography).attrs({ variant: "h2" })`
  color: ${(p) => p.theme.colors.borderGrey};
  text-align: center;
  font-size: 20px;
  font-weight: 400;
  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 24px;
  }
`
const StyledButton = styled(Button)`
  color: ${(p) => p.theme.colors.borderGrey};
  background: none;
  border: 1px solid ${(p) => p.theme.colors.borderGrey};
  margin-top: 50px;
  &:hover {
    background: none;
    transform: none;
  }
`

const StyledSvg = styled.div`
  position: absolute;
  cursor: pointer;
  right: 50px;
  top: 50px;
  z-index: 10000;
  ${(p) => p.theme.breakpoints.down("sm")} {
    right: 25px;
    top: 25px;
  }
  svg {
    path {
      stroke: ${(p) => p.theme.colors.white};
    }
  }
`

const StyledIconWrapper = styled.div`
  position: absolute;
  bottom: 50px;
  display: flex;
  justify-content: center;
  width: 100%;
  cursor: move;
`
const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    background: ${(p) => p.theme.colors.black};
  }
`

type ImageViewerProps = {
  data: ModelInsidePanorama
}
// "https://www.mazda.co.il/Uploads//ecom/2%20IPM4/Interior/Dynamic/Mazda2_DJLT_DHN9LAA_42S_D1H_INT_Sphere_TransparentPNG.png"
const ImageViewer = ({ data }: ImageViewerProps) => {
  const [open, setOpen] = useState(false)
  return (
    <>
      <StyledImageWrapper>
        <Image
          src={data?.poster?.desktopImageUrl}
          alt={data?.poster?.alt || ""}
          role="presentation"
          aria-hidden="true"
          fill
          sizes="100vw"
        />
        <StyledInfoWrapper>
          <StyledText>{data?.title}</StyledText>
          <StyledButton
            onClick={() => {
              setOpen(true)
            }}
            aria-label="מוזמנים להיכנס - חלונית תצוגה בתלת מימד של הדגם"
          >
            מוזמנים להיכנס
          </StyledButton>
        </StyledInfoWrapper>
      </StyledImageWrapper>
      <StyledDialog fullScreen open={open} onClose={() => setOpen(false)}>
        <PhotoSphereComponent src={data?.panorama?.desktopImageUrl}>
          <StyledSvg
            onClick={() => setOpen(false)}
            role="button"
            tabIndex={0}
            aria-label="סגירה"
          >
            <CloseIcon />
          </StyledSvg>
          <StyledIconWrapper>
            <TablerView360Icon />
          </StyledIconWrapper>
        </PhotoSphereComponent>
      </StyledDialog>
    </>
  )
}

export default ImageViewer
